import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const useStyles = makeStyles((theme) => ({
  bottomSpacing: {
    marginBottom: theme.spacing(5)
  },
  factorCount: {
    fontSize: 12,
    color: theme.colorPalette.green_75
  },
  cardContent: {
    padding: theme.spacing(0, 6, 6),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4)
  },
  subsection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  subsectionTitle: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '24px',
    color: theme.colorPalette.green_90,
    margin: 0
  },
  carSubsectionTitle: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '24px',
    color: theme.colorPalette.green_75,
    margin: 0
  },
  personSubsectionHeader: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(2)
  },
  roleLabel: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px',
    color: theme.colorPalette.orange_75,
    marginBottom: theme.spacing(0.5)
  },
  contentBox: {
    background: theme.colorPalette.white,
    border: `2px solid ${theme.colorPalette.beige_40}`,
    borderRadius: theme.sizes.roundCorners,
    padding: theme.spacing(6),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    ...reskinStyles(theme, theme.cardStyles.inset)
  },
  factorDivider: {
    borderBottom: `1px solid ${theme.onCardDivider.beige_50}`,
    margin: 0
  },
  factorTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  factorViolationTitle: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    color: theme.colorPalette.green_90
  },
  factorPropertyTitle: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    color: theme.colorPalette.green_80
  },
  factorDescription: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.colorPalette.green_75,
    margin: 0
  },
  factorMetadata: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    fontSize: 12,
    color: theme.colorPalette.green_75
  },
  buttons: {
    paddingTop: theme.spacing(5),
    '& .MuiButton-root': {
      paddingLeft: `${theme.spacing(4)}px !important`,
      paddingRight: `${theme.spacing(4)}px !important`
    }
  },
  buttonIcon: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    marginRight: theme.spacing(1.5),
    filter: 'brightness(0) invert(1)',
    ...reskinStyles(theme, { filter: 'none' })
  }
}));

export default useStyles;
